<app-cabecalho-direita [data]="data.CABECALHO"></app-cabecalho-direita>
<app-solucoes [data]="data.SOLUCOES"></app-solucoes>
<app-exemplos [data]="data.EXEMPLOS"></app-exemplos>